export default __webpack_public_path__ + "static/media/securitu-privacy-1.ceb3cfa1.png";